import ContactsActions from '../actions/ContactsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { ContactsState, Contact } from '../interfaces/contacts';
import { Pagination } from '../store-interfaces';
import TagsCRUDActions from '../actions/TagsCRUDActions';
import TagModel from '../model/TagModel';
import { unionBy } from 'lodash';

const initialState: ContactsState = {
  busy: false,
  selectedContact: null,
  contactsBlob: null,
  contacts: [],
  allContacts: [],
  hotLeads: [],
  pagination: {} as Pagination,
};

const updateContactByTagsChange = (
  state: ContactsState,
  action: { entities: { tags: TagModel[]; contactId: number } },
) => {
  const { entities } = action;
  let selectedContact = state.selectedContact;

  if (
    state.selectedContact &&
    state.selectedContact.id === entities.contactId
  ) {
    selectedContact = Object.assign({}, selectedContact, {
      tags: entities.tags,
    });
  }

  return {
    ...state,
    busy: false,
    selectedContact,
    contacts: state.contacts.map((contact: Contact) => {
      if (contact.id === entities.contactId) {
        return { ...contact, tags: entities.tags };
      }
      return contact;
    }),
  };
};

export default function contacts(
  state: ContactsState = initialState,
  action,
): ContactsState {
  switch (action.type) {
    case ContactsActions.busyAction:
      return setBusy(state);
    case ContactsActions.retrievedAllAction: {
      const { entities } = action;
      return {
        ...state,
        busy: false,
        contacts: entities.contacts,
        allContacts: unionBy(state.allContacts, entities.contacts),
        pagination: entities.pagination,
        selectedContact: null,
      };
    }

    case ContactsActions.retrievedHotLeadsAction: {
      const { hotLeads } = action;

      return {
        ...state,
        hotLeads,
      };
    }

    case TagsCRUDActions.assignTagAction:
      return updateContactByTagsChange(state, action);

    case TagsCRUDActions.unassignTagAction:
      return updateContactByTagsChange(state, action);

    case ContactsActions.retrievedAction: {
      const { entity } = action;
      const newState = {
        ...state,
        busy: false,
        contacts: state.contacts.map(c => (c.id === entity.id ? entity : c)),
      };
      if (entity instanceof Blob) {
        newState.contactsBlob = entity;
      } else {
        newState.selectedContact = entity;
      }
      return newState;
    }
    case ContactsActions.setLocalSelectedPageAction:
      return { ...state, selectedContact: action.payload };
    case ContactsActions.resetAllContactsAction: {
      return {
        ...state,
        allContacts: [],
      };
    }
    case ContactsActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
